import { z } from "zod";

const slugPattern = /^[a-z0-9-]+$/;

export const createOrganizationSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be less than 100 characters"),
  slug: z
    .string()
    .min(2, "Slug must be at least 2 characters")
    .max(100, "Slug must be less than 100 characters")
    .regex(slugPattern, "Slug must contain only lowercase letters, numbers, and hyphens")
    .optional(),
});

export const updateOrganizationSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be less than 100 characters")
    .optional(),
  slug: z
    .string()
    .min(2, "Slug must be at least 2 characters")
    .max(100, "Slug must be less than 100 characters")
    .regex(slugPattern, "Slug must contain only lowercase letters, numbers, and hyphens")
    .optional(),
});

export const inviteMemberSchema = z.object({
  email: z.string().email("Please enter a valid email address").toLowerCase(),
  role: z.enum(["owner", "admin", "member"] as const),
});

export type CreateOrganizationFormData = z.infer<typeof createOrganizationSchema>;
export type UpdateOrganizationFormData = z.infer<typeof updateOrganizationSchema>;
export type InviteMemberFormData = z.infer<typeof inviteMemberSchema>;
